export const HIDE_DELETED_WORDS_CLASSNAME = 'Transcript__hideDeleted';
export const ACTIVE_SUGGESTION_CLASSNAME = 'Transcript__suggestionActive';
